module.exports = __webpack_public_path__ + "assets/235d9dced67735ee9939f59ec6ed0073.mp3";